module.exports = __webpack_public_path__ + "static/img/askZheo.4f266dd6.png";